import { FC } from 'react'
import TabPanel from '../../../components/LibraryDetailsTabPanel'
import AboutTab from '../../about-tab'
import { DevicesTabs } from '../../../useLibraryDetailsData'
import { useLibraryDetails } from 'contexts/LibraryDetailsContext'

export const AboutTabPanel: FC = () => {
  const { tabValue, active, activeSources, potentialSources, notConfiguredInstancesApplicableToCpi } =
    useLibraryDetails()

  return (
    <TabPanel value={tabValue === DevicesTabs.About ? (active ? 2 : 0) : 10} index={active ? 2 : 0}>
      <AboutTab
        potentialSources={potentialSources}
        activeSources={activeSources}
        notConfiguredInstancesApplicableToCpi={notConfiguredInstancesApplicableToCpi}
      />
    </TabPanel>
  )
}
